module.exports = jQuery;


/*****************
 ** WEBPACK FOOTER
 ** external "jQuery"
 ** module id = 2
 ** module chunks = 0 1
 **/